// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    text_delete: 'Usuń pole',
    text_edit: 'Edituj pole',
    text_filter: 'Pola niestandardowe dla',
    text_include_in_unportfolioed_projects: 'Uwzględnij te, które nie mają portfel',
    text_isRequired: 'Pole wymagane',
    text_restricted_by_portfolio: 'Ograniczenie według portfeli',
};
